module.exports = __webpack_public_path__ + "static/media/slide-down-arrow.eb90c325.svg";